module.exports = __webpack_public_path__ + "static/media/20240530085345_IMG_7479.b8751f65.JPG";